import {
  COURSEID,
  CURRENTTAB,
  MODULE_C,
  ADDASSESSMENT,
  CHECKSTATE,
  ISUPDATEQUIZ,
} from "redux/constants/DetailConstants";

const INITIAL_STATE = {
  moduleCourse: [],
  CourseId: "",
  currentTab: "1",
  addAssessment: false,
  checkState: false,
  isUpdateQuiz: false,
};

const DetailCourse = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODULE_C:
      return { ...state, moduleCourse: action.payload };

    case COURSEID:
      return { ...state, CourseId: action.payload };
    case CURRENTTAB:
      return { ...state, currentTab: action.payload };
    case ADDASSESSMENT:
      return { ...state, addAssessment: action.payload };
    case CHECKSTATE:
      return { ...state, checkState: action.payload };
    case ISUPDATEQUIZ:
      return { ...state, isUpdateQuiz: action.payload };
    default:
      return state;
  }
};

export default DetailCourse;
